<template>
  <div>
    <v-btn
      v-if="currentUser?.hasPermission('guard_reports.download_guardreport')"
      class="mr-3 text-capitalize"
      color="primary"
      flat
      :loading="isDownloading"
      :disabled="loading"
      @click="emit('download-report-pressed')"
      >Download PDF</v-btn
    >

    <MoreOptionsMenuButton
      :disabled="loading || isDownloading"
      v-if="
        currentUser!.hasPermission('geoaudit.view_locationlog') ||
        currentUser?.hasPermission('guard_reports.add_guardreportsummary') ||
        currentUser?.hasPermission('guard_reports.change_guardreportsummary')
      "
    >
      <template #button="props">
        <v-btn
          v-bind="props"
          :loading="loading"
          :disabled="loading || isDownloading"
          class="mr-3 text-capitalize"
          append-icon="mdi-menu-down"
          variant="outlined"
        >
          More Options
        </v-btn>
      </template>

      <v-list-item
        v-if="currentUser!.hasPermission('geoaudit.view_locationlog')"
        title="View Coordinates"
        @click="emit('report-coordinates-pressed')"
      >
      </v-list-item>
      <v-list-item
        v-if="currentUser?.hasPermission('guard_reports.add_guardreportsummary') && !summaryExists"
        title="Create Summary Report"
        @click="emit('create-summary-report-pressed')"
      >
      </v-list-item>
      <v-list-item
        v-if="
          currentUser?.hasPermission('guard_reports.change_guardreportsummary') && summaryExists
        "
        title="Edit Summary Report"
        @click="emit('edit-summary-report-pressed')"
      >
      </v-list-item>
      <v-list-item
        v-if="currentUser?.hasPermission('guard_reports.approve_guardreport')"
        title="Share Report"
        @click="emit('share-report-pressed')"
      >
      </v-list-item>
    </MoreOptionsMenuButton>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  loading?: boolean
  summaryExists?: boolean
  isDownloading?: boolean
}
defineProps<Props>()

interface Emit {
  (e: 'create-summary-report-pressed'): void
  (e: 'edit-summary-report-pressed'): void
  (e: 'download-report-pressed'): void
  (e: 'report-coordinates-pressed'): void
  (e: 'share-report-pressed'): void
}
const emit = defineEmits<Emit>()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
